(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ozzi-biomend-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (!root || root.dataset.bmReady) return;
    root.dataset.bmReady = 'true';
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const dialog = root.querySelector('.bm-dialog');
    let opener;
    root.querySelectorAll('[data-bm-image]').forEach(button => button.addEventListener('click', () => {
      opener = button;
      const selected = root.querySelector('[data-bm-slide][aria-pressed="true"]');
      const gallery = button.dataset.bmImage === 'gallery';
      const isLabel = button.dataset.bmImage === 'label' || (gallery && selected?.dataset.bmSlide === 'label');
      const img = dialog.querySelector('img');
      img.src = isLabel ? (root.dataset.labelImage || 'assets/biomend-label.png') : (root.dataset.bottleImage || 'assets/biomend-bottle-original.png');
      if (gallery && selected) img.src = selected.querySelector('img').src;
      img.alt = isLabel ? 'Original Ozzi BIOMEnd bottle label. Scroll horizontally to inspect all panels.' : 'Original Ozzi BIOMEnd bottle artwork';
      dialog.classList.toggle('bm-dialog-label', isLabel);
      dialog.querySelector('.bm-dialog-caption').textContent = isLabel ? (root.dataset.labelCaption || 'Original label artwork. Scroll sideways to read all panels.') : (root.dataset.bottleCaption || 'Ozzi BIOMEnd Butyrate · 112 capsules');
      if (gallery && selected) {
        img.alt = selected.querySelector('img').alt;
        dialog.querySelector('.bm-dialog-caption').textContent = root.querySelector('[data-bm-gallery-caption]').textContent;
      }
      dialog.showModal();
      dialog.querySelector('.bm-dialog-scroll').scrollLeft = 0;
    }));
    dialog.querySelector('.bm-dialog-close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); }});
    dialog.addEventListener('close', () => opener?.focus());
    const videos = [...root.querySelectorAll('[data-bm-video]')];
    const motionToggles = [...root.querySelectorAll('.bm-motion-toggle')];
    const visibleVideos = new Set();
    const syncVideo = (video) => {
      const allowed = !reduced.matches && !root.classList.contains('bm-motion-paused') && !video.hidden && !document.hidden && visibleVideos.has(video);
      if (!allowed) {
        video.pause();
        if (reduced.matches) video.classList.remove('bm-video-ready');
        return;
      }
      if (!video.getAttribute('src') && video.dataset.src) video.src = video.dataset.src;
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      video.controls = false;
      video.playbackRate = .7;
      video.play()?.catch(() => video.classList.remove('bm-video-ready'));
    };
    const syncAll = () => videos.forEach(syncVideo);
    videos.forEach(video => {
      video.addEventListener('playing', () => { if (!reduced.matches) video.classList.add('bm-video-ready'); });
      video.addEventListener('error', () => video.classList.remove('bm-video-ready'));
    });
    motionToggles.forEach(toggle => toggle.addEventListener('click', () => {
      const paused = root.classList.toggle('bm-motion-paused');
      motionToggles.forEach(button => {
        button.setAttribute('aria-pressed', String(paused));
        button.textContent = paused ? (root.dataset.resumeLabel || 'Resume motion') : (root.dataset.pauseLabel || 'Pause motion');
      });
      syncAll();
    }));
    reduced.addEventListener('change', syncAll);
    document.addEventListener('visibilitychange', syncAll);
    const slides = [...root.querySelectorAll('[data-bm-slide]')];
    const bmGal = root.querySelector('.bm-gallery');
    const bmGalTop = () => {
      const hdr = document.querySelector('.section-header');
      const h = hdr && getComputedStyle(hdr).position === 'sticky' ? hdr.getBoundingClientRect().height : 0;
      bmGal.style.setProperty('--bm-gal-top', (h + 20) + 'px');
    };
    if (bmGal) { bmGalTop(); window.addEventListener('resize', bmGalTop); window.addEventListener('load', bmGalTop); }
    const galleryImage = root.querySelector('.bm-bottle');
    const galleryZoom = root.querySelector('.bm-bottle-button');
    let slideIndex = 0;
    const selectSlide = (index) => {
      slideIndex = (index + slides.length) % slides.length;
      const selected = slides[slideIndex];
      slides.forEach(button => button.setAttribute('aria-pressed', String(button === selected)));
      const sourceImage = selected.querySelector('img');
      galleryImage.src = sourceImage.src;
      galleryImage.alt = sourceImage.alt;
      galleryZoom.dataset.bmImage = 'gallery';
      galleryZoom.setAttribute('aria-label', selected.getAttribute('aria-label') || sourceImage.alt);
      root.querySelector('[data-bm-gallery-caption]').textContent = sourceImage.alt;
      root.querySelector('[data-bm-gallery-index]').textContent = String(slideIndex + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');


    };
    slides.forEach((button, index) => {
      button.addEventListener('click', () => {
        selectSlide(index);
        galleryZoom.scrollIntoView({block:'nearest',behavior:reduced.matches?'instant':'smooth'});
      });
      button.addEventListener('keydown', event => {
        const offset = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
        if (!offset) return;
        event.preventDefault();
        selectSlide(index + offset);
        slides[slideIndex].focus({preventScroll:true});
        slides[slideIndex].scrollIntoView({block:'nearest',inline:'nearest',behavior:reduced.matches?'instant':'smooth'});
      });
    });
    root.querySelector('[data-bm-prev]')?.addEventListener('click', () => selectSlide(slideIndex - 1));
    root.querySelector('[data-bm-next]')?.addEventListener('click', () => selectSlide(slideIndex + 1));
    if ('IntersectionObserver' in window) {
      const motionObserver = new IntersectionObserver(entries => entries.forEach(entry => {
        entry.target.classList.toggle('bm-offscreen', !entry.isIntersecting);
        if (entry.target.matches('[data-bm-video]')) {
          if (entry.isIntersecting) visibleVideos.add(entry.target); else visibleVideos.delete(entry.target);
          syncVideo(entry.target);
        }
      }), {rootMargin:'80px'});
      root.querySelectorAll('[data-bm-motion], [data-bm-video]').forEach(node => motionObserver.observe(node));
      if (!reduced.matches) {
        const revealObserver = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.remove('bm-reveal-pending'); revealObserver.unobserve(entry.target); } }), {threshold:.08});
        root.querySelectorAll('[data-bm-reveal]').forEach(node => { if (node.getBoundingClientRect().top > window.innerHeight) { node.classList.add('bm-reveal-pending'); revealObserver.observe(node); }});
      }
    } else {
      videos.forEach(video => visibleVideos.add(video));
      syncAll();
    }
    const waitlist = root.querySelector('[data-bm-waitlist]');
    if (waitlist) {
      const email = waitlist.querySelector('[name="email"]');
      const submit = waitlist.querySelector('[type="submit"]');
      const label = waitlist.querySelector('[data-bm-waitlist-label]');
      const status = waitlist.querySelector('[role="status"]');
      const idleLabel = label.textContent;
      let sending = false;
      submit.disabled = false;
      waitlist.addEventListener('submit', async event => {
        event.preventDefault();
        if (sending || waitlist.dataset.joined === 'true' || !waitlist.reportValidity()) return;
        sending = true;
        submit.disabled = true;
        email.readOnly = true;
        waitlist.setAttribute('aria-busy', 'true');
        label.textContent = waitlist.dataset.loading;
        status.textContent = '';
        status.classList.remove('bm-error');
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);
        try {
          const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(waitlist.dataset.company), {
            method: 'POST',
            headers: {'Content-Type':'application/vnd.api+json', revision:'2026-07-15'},
            signal: controller.signal,
            body: JSON.stringify({data: {
              type: 'subscription',
              attributes: {
                custom_source: 'BIOMEnd product launch waitlist',
                profile: {data: {type:'profile', attributes: {
                  email: email.value.trim(),
                  subscriptions: {email:{marketing:{consent:'SUBSCRIBED'}}},
                  properties: {biomend_launch_waitlist: true, biomend_signup_source: 'product-page'}
                }}}
              },
              relationships: {list:{data:{type:'list',id:waitlist.dataset.list}}}
            }})
          });
          if (!response.ok) {
            status.textContent = response.status === 429 ? waitlist.dataset.rateError : waitlist.dataset.error;
            throw new Error('Subscription not accepted');
          }
          label.textContent = waitlist.dataset.done;
          status.textContent = waitlist.dataset.success;
          waitlist.dataset.joined = 'true';
        } catch (error) {
          status.textContent ||= waitlist.dataset.error;
          status.classList.add('bm-error');
          label.textContent = idleLabel;
          submit.disabled = false;
          email.readOnly = false;
        } finally {
          clearTimeout(timeout);
          sending = false;
          waitlist.removeAttribute('aria-busy');
        }
      });
    }
  };
  document.querySelectorAll('.bm').forEach(init);
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('.bm')));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ozzi-capsules-v2"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    root.classList.add('cv2-js');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    const slides = [...root.querySelectorAll('[data-slide]')];
    const hasGallery = slides.length > 0;
    const choices = [...root.querySelectorAll('[data-slide-to]')];
    let slide = 0;
    function showSlide(index, announce = false) {
      slide = (index + slides.length) % slides.length;
      slides.forEach((item, n) => {
        item.classList.toggle('is-active', n === slide);
        item.hidden = n !== slide;
      });
      choices.forEach((item, n) => item.setAttribute('aria-pressed', String(n === slide)));
      root.querySelector('[data-gallery-caption]').textContent = slides[slide].dataset.galleryNote || '';
      root.querySelector('[data-gallery-index]').textContent = `${slide + 1} / ${slides.length}`;
      if (announce) root.querySelector('[data-gallery-status]').textContent = slides[slide].getAttribute('aria-label');
    }
    if (hasGallery) {
    choices.forEach((button, i) => {
      button.addEventListener('click', () => showSlide(i, true));
      button.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (i + 1) % choices.length;
        if (event.key === 'ArrowLeft') next = (i - 1 + choices.length) % choices.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = choices.length - 1;
        if (next !== undefined) {
          event.preventDefault();
          showSlide(next, true);
          choices[next].focus({ preventScroll: true });
        }
      });
    });
    root.querySelector('[data-slide-prev]').addEventListener('click', () => showSlide(slide - 1, true));
    root.querySelector('[data-slide-next]').addEventListener('click', () => showSlide(slide + 1, true));
    const stage = root.querySelector('.cv2-gallery-stage');
    const gal = root.querySelector('.cv2-gallery');
    const galTop = () => {
      const hdr = document.querySelector('.section-header');
      const h = hdr && getComputedStyle(hdr).position === 'sticky' ? hdr.getBoundingClientRect().height : 0;
      gal.style.setProperty('--cv2-gal-top', (h + 20) + 'px');
    };
    galTop();
    window.addEventListener('resize', galTop);
    if (window.ResizeObserver) new ResizeObserver(galTop).observe(gal);
    root.querySelector('[data-stage-prev]').addEventListener('click', e => { e.stopPropagation(); showSlide(slide - 1, true); });
    root.querySelector('[data-stage-next]').addEventListener('click', e => { e.stopPropagation(); showSlide(slide + 1, true); });
    stage.addEventListener('click', e => { if (window.matchMedia('(min-width: 761px)').matches && e.target.closest('.cv2-slide')) showSlide(slide + 1, true); });
    let sx = null, sy = 0;
    stage.addEventListener('touchstart', e => { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    stage.addEventListener('touchend', e => {
      if (sx === null) return;
      const dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      sx = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) showSlide(slide + (dx < 0 ? 1 : -1), true);
    }, { passive: true });
    // Slide and thumbnail labels say "n of 5"; a lead image makes six: number them from what is on the page.
    slides.forEach((s, n) => { const l = s.getAttribute('aria-label'); if (l) s.setAttribute('aria-label', `${n + 1} of ${slides.length}: ` + l.replace(/^\d+ of \d+: /, '')); });
    choices.forEach((b, n) => { const l = b.getAttribute('aria-label'); if (l) b.setAttribute('aria-label', `Show image ${n + 1}: ` + l.replace(/^Show image \d+: /, '')); });
    showSlide(0);
    }
    // jump_offer (2026-10-24 review): on phones #build and #ozlst-buy land on the offer (the case bar and the for-life
    // strip, then the supply cards or the single offer's button) instead of the top of the gallery.
    if (root.dataset.jumpOffer && window.matchMedia('(max-width: 760px)').matches) {
      const spot = root.querySelector('.cv2-buy .cv2-casebar, .cv2-buy .cv2-offrow, .cv2-buy [data-cv2-bundles], .cv2-buy .cv2-add-to-cart');
      const ancs = ['build', 'ozlst-buy'].map(id => root.querySelector('#' + id + '.cv2-anchor')).filter(Boolean);
      if (spot && ancs.length) {
        const hdr = document.querySelector('.section-header');
        const h = hdr && getComputedStyle(hdr).position === 'sticky' ? hdr.getBoundingClientRect().height : 0;
        ancs.forEach(a => { spot.before(a); a.style.top = -(h + 12) + 'px'; });
        const hit = ancs.find(a => '#' + a.id === location.hash);
        if (hit) hit.scrollIntoView();
      }
    }

    // Original formula leads with its two patented ingredients: BIOMEnd first, Metabolex second.
    if (root.classList.contains('cv2--orig')) ['chromium', 'butyrate'].forEach(k => {
      const t = root.querySelector(`[data-ingredient="${k}"]`), p = root.querySelector(`[data-panel="${k}"]`);
      if (t) t.parentNode.prepend(t);
      if (p) p.parentNode.prepend(p);
    });
    const tabs = [...root.querySelectorAll('[data-ingredient]')];
    const panels = [...root.querySelectorAll('[data-panel]')];
    const nav = root.querySelector('.cv2-ingredient-nav');
    if (nav) nav.setAttribute('role', 'tablist');
    tabs.forEach(t => t.setAttribute('role', 'tab'));
    panels.forEach(p => { p.setAttribute('role', 'tabpanel'); p.tabIndex = 0; });
    function chooseIngredient(index, focus = false) {
      tabs.forEach((tab, n) => {
        tab.setAttribute('aria-selected', String(index === n));
        tab.tabIndex = index === n ? 0 : -1;
      });
      panels.forEach((panel, n) => {
        panel.hidden = index !== n;
        panel.classList.toggle('is-active', index === n);
      });
      root.querySelector('[data-motion-name]').textContent = tabs[index].querySelector('span').textContent;
      root.querySelector('[data-motion-role]').textContent = panels[index].querySelector('.cv2-eyebrow').textContent;
      root.querySelector('[data-motion-index]').textContent = `${String(index + 1).padStart(2,'0')} / ${String(tabs.length).padStart(2,'0')}`;
      if (focus) tabs[index].focus();
    }
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => chooseIngredient(index));
      tab.addEventListener('keydown', e => {
        let next;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (index + 1) % tabs.length;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
        if (e.key === 'Home') next = 0;
        if (e.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { e.preventDefault(); chooseIngredient(next, true); }
      });
    });
    if (tabs.length) chooseIngredient(0);

    const video = root.querySelector('[data-motion]');
    const toggle = root.querySelector('[data-motion-toggle]');
    let userPaused = false;
    let inView = false;
    let loaded = false;
    const pauseLabel = root.dataset.pauseLabel || 'Pause motion';
    const resumeLabel = root.dataset.resumeLabel || 'Resume motion';
    function updateVideo() {
      if (!video) return;
      const shouldPlay = inView && !document.hidden && !reduce.matches && !userPaused;
      if (shouldPlay) {
        if (!loaded) {
          video.querySelectorAll('source[data-src]').forEach(s => { s.src = s.dataset.src; });
          video.load();
          loaded = true;
        }
        video.muted = true;
        video.play().catch(() => { video.classList.remove('is-ready'); toggle.hidden = true; });
      } else video.pause();
      toggle.textContent = userPaused ? resumeLabel : pauseLabel;
      toggle.setAttribute('aria-pressed', String(userPaused));
    }
    if (video) {
      video.addEventListener('playing', () => { video.classList.add('is-ready'); toggle.hidden = false; });
      video.addEventListener('error', () => { video.classList.remove('is-ready'); toggle.hidden = true; });
      toggle.addEventListener('click', () => { userPaused = !userPaused; updateVideo(); });
    }

    (() => {
      const box = root.querySelector('[data-cv2-bundles]'); if (!box) return;
      const idIn = root.querySelector('[data-cv2-id-input]'), planIn = root.querySelector('[data-cv2-bundle-plan]');
      const form = idIn && idIn.form;
      const qtyIn = form && form.querySelector('[name=quantity]');
      
      const money = c => '$' + (c / 100).toFixed(2);
      const GIFT_PRODUCTS = [15382883991751, 15382884024519, 15410405671111, 8396098273479];
      let buyingOnce = false;
      const card = () => { const s = box.querySelector('input:checked'); return s && s.closest('.cv2-bundle'); };
      const totals = () => {
        box.querySelectorAll('.cv2-bundle').forEach(c => {
          const sel = c.querySelector('[data-gift-select]'); if (!sel) return;
          const o = sel.selectedOptions[0], drink = Number(o.dataset.price);
          const extra = Number(c.dataset.bioPrice || 0) + Number(c.dataset.casePrice || 0) + Number(c.dataset.samplePrice || 0);
          c.querySelector('[data-gift-total]').textContent = '$' + Math.round((drink + extra) / 100);
          const bg = c.querySelector('[data-badge-gift]'); if (bg) bg.textContent = '$' + Math.round((drink + extra) / 100);
          c.querySelector('[data-gift-drink-val]').textContent = '$' + Math.round(drink / 100);
          const img = c.querySelector('[data-gift-img]'); if (img && o.dataset.img) img.src = o.dataset.img;
        });
      };
      const sync = () => {
        const c = card();
        box.querySelectorAll('.cv2-bundle').forEach(x => x.classList.toggle('is-selected', x === c));
        if (!c) return;
        const mainImg = root.querySelector('[data-variant-main]'), thumbImg = root.querySelector('[data-variant-thumb]');
        if (c.dataset.img && mainImg && mainImg.getAttribute('src') !== c.dataset.img) {
          mainImg.src = c.dataset.img; mainImg.alt = c.dataset.alt || mainImg.alt;
          if (thumbImg) thumbImg.src = c.dataset.thumb;
          const vi = Math.max(0, slides.indexOf(mainImg.closest('[data-slide]')));
          if (vi === 0 && slide !== vi) showSlide(vi);
        }
        // No buy form in waitlist mode: the cards are shown for their prices and gifts only.
        if (idIn && planIn) { idIn.value = c.dataset.variant; planIn.value = c.dataset.plan; planIn.disabled = false; }
        if (qtyIn) qtyIn.value = c.dataset.qty || 1;
        const ap = root.querySelector('[data-atc-price]');
        if (ap) ap.innerHTML = (ap.dataset.sep || ' · ') + c.dataset.total + (!('plain' in ap.dataset) && c.dataset.compare !== c.dataset.total ? ' <s>' + c.dataset.compare + '</s>' : '');
      };
      box.addEventListener('change', sync);
      box.querySelectorAll('[data-gift-select]').forEach(s => {
        s.addEventListener('click', e => e.stopPropagation());
        s.addEventListener('change', () => { const r = s.closest('.cv2-bundle').querySelector('input[type=radio]'); if (!r.checked) { r.checked = true; sync(); } totals(); });
      });
      sync(); totals();

      const once = root.querySelector('[data-cv2-buy-once]');
      if (once && form) once.addEventListener('click', () => {
        buyingOnce = true; idIn.value = once.dataset.variant; planIn.disabled = true; if (qtyIn) qtyIn.value = 1;
        form.requestSubmit ? form.requestSubmit() : form.submit();
        setTimeout(() => { buyingOnce = false; sync(); }, 1500);
      });

      // Bundles with gifts go in as one /cart/add.js call: the capsules on their plan plus the free items.
      // Then straight to checkout (snippets/ozzi-checkout); every other buy on this page goes through
      // product-form.js, which does the same. The button keeps its loading state until the browser leaves.
      if (form) form.addEventListener('submit', async e => {
        const c = card();
        // A card whose only gift is the travel case goes through product-form.js; oz-cart.js adds the case.
        if (buyingOnce || !c || !/drink|bio|sample/.test(c.dataset.gifts || '')) return;
        e.preventDefault(); e.stopImmediatePropagation();
        const btn = form.querySelector('[type=submit]');
        // Already on its way (this handler or product-form.js): a second tap must not add the bundle again.
        if (btn.getAttribute('aria-disabled') === 'true') return;
        btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading');
        const items = [{ id: Number(c.dataset.variant), quantity: Number(c.dataset.qty || 1), selling_plan: Number(c.dataset.plan) }];
        const flavor = c.querySelector('[data-gift-select]');
        if (flavor) items.push({ id: Number(flavor.value), quantity: 1, properties: { _capsule_gift: 'drink' } });
        if (c.dataset.gifts.includes('bio')) items.push({ id: Number(c.dataset.bio), quantity: 1, properties: { _capsule_gift: 'bio' } });
        if (c.dataset.gifts.includes('sample')) items.push({ id: Number(c.dataset.sample), quantity: 1, properties: { _capsule_gift: 'sample' } });
        if (c.dataset.gifts.includes('case')) items.push({ id: Number(c.dataset.case), quantity: 1, properties: { _capsule_gift: 'case' } });
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const body = { items };
        const toCheckout = !!window.OzziCheckout;
        let leaving = false;
        if (!toCheckout && cart && cart.getSectionsToRender) { body.sections = cart.getSectionsToRender().map(s => s.id); body.sections_url = location.pathname; }
        try {
          const r = await fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
          const res = await r.json();
          if (res.status) throw new Error(res.description || res.message);
          // A gift is only kept if Shopify actually made it free.
          const now = await fetch('/cart.js').then(x => x.json());
          let pulled = false;
          for (const line of now.items) {
            if (GIFT_PRODUCTS.includes(line.product_id) && line.final_line_price > 0) {
              await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: line.key, quantity: 0 }) });
              pulled = true;
            }
          }
          // The read above still stands unless a gift was just pulled out of it.
          if (toCheckout) { leaving = true; window.OzziCheckout.go(pulled ? null : now); }
          else if (cart && cart.renderContents && res.sections) { cart.classList.remove('is-empty'); cart.renderContents(res); }
          else location.href = '/cart';
        } catch (err) {
          const w = form.closest('product-form') && form.closest('product-form').querySelector('.product-form__error-message-wrapper');
          if (w) { w.hidden = false; w.querySelector('.product-form__error-message').textContent = err.message; }
        } finally { if (!leaving) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); } }
      }, true);
    })();

    // Single offer (offer_mode 'single'): the subscription and its first-box sample pack go in as one
    // /cart/add.js call, any gift Shopify did not make free comes straight back out, then OzziCheckout.
    // assets/oz-cart.js adds the travel case to capsule subscriptions, this product included.
    (() => {
      const btn = root.querySelector('[data-cv2-single]'); if (!btn) return;
      const err = root.querySelector('[data-single-err]');
      const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const GIFT_PRODUCTS = [15382883991751, 15382884024519, 15410405671111, 8396098273479];
      btn.addEventListener('click', async () => {
        if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
        btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); if (err) err.hidden = true;
        const items = [{ id: Number(btn.dataset.variant), quantity: 1, selling_plan: Number(btn.dataset.plan) }];
        if (btn.dataset.sample) items.push({ id: Number(btn.dataset.sample), quantity: 1, properties: { _capsule_gift: 'sample' } });
        let leaving = false;
        try {
          const r = await fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
          const res = await r.json();
          if (res.status) throw new Error(res.description || res.message);
          const now = await fetch(base + 'cart.js').then(x => x.json());
          let pulled = false;
          for (const line of now.items) {
            if (GIFT_PRODUCTS.includes(line.product_id) && line.final_line_price > 0) {
              await fetch(base + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: line.key, quantity: 0 }) });
              pulled = true;
            }
          }
          if (window.OzziCheckout) { leaving = true; window.OzziCheckout.go(pulled ? null : now); }
          else location.href = base + 'cart';
        } catch (e) {
          if (err) { err.textContent = e.message || 'Something went wrong. Please try again.'; err.hidden = false; }
        } finally { if (!leaving) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); } }
      });
    })();

    (() => {
      const mq = window.matchMedia('(max-width: 760px)');
      const panels = [...root.querySelectorAll('.cv2-ingredient-panel')];
      const tops = panels.map(p => p.querySelector('.cv2-panel-top'));
      const apply = () => {
        panels.forEach((p, i) => {
          const top = tops[i];
          if (mq.matches) {
            p.hidden = false;
            top.setAttribute('role', 'button'); top.tabIndex = 0;
            top.setAttribute('aria-expanded', String(p.classList.contains('is-open')));
          } else {
            top.removeAttribute('role'); top.removeAttribute('tabindex'); top.removeAttribute('aria-expanded');
            p.hidden = !p.classList.contains('is-active');
          }
        });
      };
      tops.forEach((top, i) => {
        const toggle = () => {
          if (!mq.matches) return;
          const open = panels[i].classList.toggle('is-open');
          top.setAttribute('aria-expanded', String(open));
        };
        top.addEventListener('click', toggle);
        top.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
      });
      mq.addEventListener ? mq.addEventListener('change', apply) : mq.addListener(apply);
      apply();
    })();

    (() => {
      const mobile = window.matchMedia('(max-width: 760px)');
      const facts = root.querySelector('[data-cv2-facts]');
      
      const faq = root.querySelector('[data-cv2-faq]');
      const more = root.querySelector('[data-cv2-faq-more]');
      if (faq && more) more.addEventListener('click', () => { faq.classList.add('is-open'); more.hidden = true; });
    })();

    (() => {
      const box = root.querySelector('[data-cv2-plans]'); if (!box) return;
      const input = root.querySelector('[data-cv2-plan-input]');
      const freq = box.querySelector('[data-cv2-freq]');
      const sync = () => {
        const mode = box.querySelector('input[type=radio]:checked').value;
        box.querySelectorAll('.cv2-plan').forEach(p => p.classList.toggle('is-selected', p.dataset.plan === mode));
        input.disabled = mode !== 'sub';
        input.value = freq.value;
        const bp = root.querySelector('[data-cv2-btn-price]');
        if (bp) bp.textContent = ' · ' + (mode === 'sub' ? bp.dataset.sub : bp.dataset.once);
      };
      box.addEventListener('change', sync);
      freq.addEventListener('click', e => e.stopPropagation());
      sync();
    })();

    (() => {
      const fig = root.querySelector('[data-gba]'); if (!fig) return;
      const v = fig.querySelector('[data-gba-video]'), btn = fig.querySelector('[data-gba-toggle]');
      let seen = false, paused = false, loaded = false;
      const sync = () => {
        if (seen && !paused && !document.hidden && !reduce.matches) {
          if (!loaded) { v.querySelectorAll('source[data-src]').forEach(s => { s.src = s.dataset.src; }); v.load(); loaded = true; }
          v.play().catch(() => { btn.hidden = true; });
        } else v.pause();
        btn.textContent = paused ? resumeLabel : pauseLabel; btn.setAttribute('aria-pressed', String(paused));
      };
      v.addEventListener('playing', () => { v.classList.add('is-ready'); btn.hidden = false; });
      btn.addEventListener('click', () => { paused = !paused; sync(); });
      new IntersectionObserver(es => { seen = es[0].isIntersecting; sync(); }, { threshold: .2 }).observe(fig);
      document.addEventListener('visibilitychange', sync);
    })();
    const observer = new IntersectionObserver(entries => {
      inView = entries[0].isIntersecting;
      updateVideo();
    }, { threshold: 0.15 });
    if (video) observer.observe(video);
    const visibility = () => updateVideo();
    const motionChange = () => { if (video && reduce.matches) video.classList.remove('is-ready'); updateVideo(); };
    document.addEventListener('visibilitychange', visibility);
    reduce.addEventListener('change', motionChange);
    root._cleanup = () => { observer.disconnect(); if (video) video.pause(); document.removeEventListener('visibilitychange', visibility); reduce.removeEventListener('change', motionChange); };
  }
  document.querySelectorAll('.cv2').forEach(init);
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('.cv2')));
  document.addEventListener('shopify:section:unload', event => event.target.querySelector('.cv2')?._cleanup?.());
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ozzi-home-packets"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-packet-home]').forEach(root => {
  if (root.dataset.crushMounted) return;
  root.dataset.crushMounted = 'true';
  const button = root.querySelector('.ozj-motion');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const animations = [];
  let paused = reduced.matches;
  const animate = (el, frames, options) => {
    const animation = el.animate(frames, options);
    animations.push(animation);
    if (paused) animation.pause();
  };
  function setPaused(value) {
    paused = value;
    animations.forEach(animation => value ? animation.pause() : animation.play());
    button.setAttribute('aria-pressed', String(value));
    button.textContent = value ? 'Resume motion' : 'Pause motion';
  }
  button.addEventListener('click', () => setPaused(!paused));
  async function start() {
    await Promise.all([...root.querySelectorAll('.ozj-crush-stick img')].map(img => img.decode().catch(() => {})));
    if (reduced.matches) { setPaused(true); return; }
    root.querySelectorAll('.ozj-crush-pair').forEach((pair, index) => {
      const impact = 2600 + index * 230;
      const direction = index % 2 ? 1 : -1;
      const stick = pair.querySelector('.ozj-crush-stick');
      const food = pair.querySelector('.ozj-crush-food');
      const contactY = food.offsetTop + food.offsetHeight * .12 - stick.offsetHeight;
      animate(food.firstElementChild, [
        {opacity:0,transform:'translateY(-550px) rotate(-20deg)'},
        {opacity:1,transform:'translateY(10px) rotate(3deg)',offset:.78},
        {opacity:1,transform:'translateY(-5px) rotate(-1deg)',offset:.9},
        {opacity:1,transform:'translateY(0) rotate(0deg)'}
      ], {duration:900,delay:index*110,fill:'both',easing:'cubic-bezier(.2,.8,.2,1)'});
      animate(stick, [
        {opacity:0,transform:'translateY(-850px)',easing:'cubic-bezier(.5,0,1,1)'},
        {opacity:1,transform:`translateY(${contactY}px)`,offset:650/980,easing:'ease-out'},
        {opacity:1,transform:'translateY(12px) rotate(3deg)',offset:800/980,easing:'ease-out'},
        {opacity:1,transform:'translateY(-10px) rotate(-2deg)',offset:900/980},
        {opacity:1,transform:'translateY(0) rotate(0deg)'}
      ], {duration:980,delay:impact-650,fill:'both',easing:'linear'});
      animate(food,[
        {opacity:1,transform:'translate(0,0) scale(1)'},
        {opacity:1,transform:'translate(0,8px) scale(1.08,.55)',offset:.09},
        {opacity:1,transform:`translate(${direction*90}px,-30px) rotate(${direction*45}deg) scale(.75)`,offset:.3},
        {opacity:0,transform:`translate(${direction*700}px,320px) rotate(${direction*210}deg) scale(.3)`}
      ],{duration:650,delay:impact,fill:'both',easing:'linear'});
      animate(pair.querySelector('.ozj-crush-burst'),[{opacity:0,transform:'scale(.3)'},{opacity:.8,transform:'scale(.8)',offset:.2},{opacity:0,transform:'scale(1.6)'}],{duration:450,delay:impact,fill:'both'});
      animate(stick.firstElementChild,[{transform:'translateY(0) rotate(-2deg)'},{transform:'translateY(-10px) rotate(2deg)'},{transform:'translateY(0) rotate(-2deg)'}],{duration:5500+index*300,delay:impact+330,iterations:Infinity,easing:'ease-in-out'});
    });
    setPaused(false);
  }
  const observer = new IntersectionObserver(entries => {
    if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); start(); }
  }, {threshold:.15});
  observer.observe(root);
  reduced.addEventListener('change', event => { if(event.matches){animations.forEach(animation => animation.cancel());animations.length=0;setPaused(true);} });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ozzi-otter-story"] && !Shopify.designMode) return;
  try {
    
(() => {
  function mount(root) {
    if (!root || root.dataset.ootMounted) return;
    root.dataset.ootMounted = 'true';
    const media = window.matchMedia('(prefers-reduced-motion: reduce)');
    root.querySelectorAll('a[href^="#oot-"]').forEach(link => link.addEventListener('click', event => {
      const target = root.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({behavior:media.matches?'auto':'smooth',block:'start'});
      history.replaceState(null,'',link.getAttribute('href'));
    }));
    const scenes = [...root.querySelectorAll('[data-scene]')];
    const chapters = [...root.querySelectorAll('[data-chapter]')];
    const sceneObserver = new IntersectionObserver(entries => {
      const visible = entries.filter(entry=>entry.isIntersecting).sort((a,b)=>b.intersectionRatio-a.intersectionRatio)[0];
      if (!visible) return;
      const index = visible.target.dataset.chapter;
      scenes.forEach(scene=>scene.classList.toggle('is-active',scene.dataset.scene===index));
      root.querySelector('[data-scene-caption]').textContent = visible.target.dataset.caption;
      root.querySelector('[data-scene-count]').textContent = `${Number(index)+1} / 3`;
    }, {rootMargin:'-34% 0px -34% 0px',threshold:0});
    chapters.forEach(chapter=>sceneObserver.observe(chapter));
    root.querySelectorAll('[data-object]').forEach(button => button.addEventListener('click', () => {
      const id = button.dataset.object;
      const content = root.querySelector(`[data-object-content="${id}"]`);
      if (!content) return;
      for (const field of ['label','title','description']) {
        root.querySelector(`[data-object-${field}]`).textContent=content.querySelector(`[data-${field}]`).textContent;
      }
      root.querySelectorAll('[data-object]').forEach(item => {
        const selected=item.dataset.object===id;
        item.setAttribute('aria-pressed',String(selected));
        item.classList.toggle('is-active',selected);
      });
    }));
    root._ootCleanup=()=>sceneObserver.disconnect();
  }
  document.querySelectorAll('[data-otter-story]').forEach(mount);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-otter-story]').forEach(mount));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-otter-story]').forEach(root=>root._ootCleanup?.()));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ozzi-seed-landing"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initialize(root) {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const data = JSON.parse(root.querySelector('#ozs-product-data').textContent);
    const $ = selector => root.querySelector(selector);
    const $$ = selector => [...root.querySelectorAll(selector)];
    const text = data.strings;
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:data.currency || 'USD'}).format(cents / 100);
    let variant = data.variants.find(item => item.id === data.initialVariant);
    let busy = false;
    const form = $('#ozs-product-form');
    const frequency = $('#ozs-frequency');
    const error = $('#ozs-cart-error');
    function updatePrice() {
      const hasPlans = variant.plans.length > 0;
      if (!hasPlans) $('input[value="onetime"]').checked = true;
      const subscribed = hasPlans && $('input[name="ozs_plan"]:checked').value === 'subscription';
      const plan = variant.plans.find(item => String(item.id) === frequency.value) || variant.plans[0];
      $('#ozs-subscription-label').hidden = !hasPlans;
      $('#ozs-subscription-details').hidden = !subscribed;
      frequency.disabled = busy || !subscribed;
      form.querySelectorAll('fieldset').forEach(fieldset => { fieldset.disabled = busy; });
      const price = subscribed ? plan.price : variant.price;
      $('#ozs-button-price').textContent = money(price);
      $('#ozs-sticky-price').textContent = money(price);
      $('.ozs-sub-price').textContent = plan ? money(plan.price) : '';
      $('.ozs-one-price').textContent = money(variant.price);
      const savings = plan && variant.price > 0 ? Math.round((variant.price - plan.price) / variant.price * 100) : 0;
      $('#ozs-savings').textContent = savings > 0 ? `${savings}%` : '';
      $('#ozs-variant-id').value = variant.id;
      $('#ozs-purchase').disabled = busy || !variant.available;
      $('#ozs-purchase-label').textContent = busy ? text.adding : variant.available ? text.get_started : text.sold_out;
      $$('.ozs-plan').forEach(label => label.classList.toggle('ozs-selected', label.querySelector('input').checked));
    }
    function updateFlavor() {
      const previousPlan = frequency.value;
      frequency.replaceChildren(...variant.plans.map(plan => {
        const option = document.createElement('option');
        option.value = plan.id;
        option.textContent = plan.name;
        return option;
      }));
      if (variant.plans.some(plan => String(plan.id) === previousPlan)) frequency.value = previousPlan;
      $$('[data-variant]').forEach(button => {
        const active = Number(button.dataset.variant) === variant.id;
        button.classList.toggle('ozs-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      $('#ozs-flavor-name').textContent = variant.name;
      $('#ozs-flavor-note').textContent = variant.name + ' · ' + (variant.name === 'Peach Elderflower' ? text.bestseller : text.sticks);
      $('#ozs-hero-flavor').textContent = variant.name;
      $('#ozs-hero-pack').src = variant.image;
      $('#ozs-hero-pack').alt = 'Ozzi ' + variant.name + ' ' + text.pouch;
      $('#ozs-sticky-pack').src = variant.image;
      $('#ozs-sticky-description').textContent = variant.name + ' · ' + text.sticks;
      $('.ozs-hero-image').dataset.image = variant.image;
      $('.ozs-hero-image').dataset.caption = variant.name + ' · ' + text.sticks;
      $('.ozs-hero-image').setAttribute('aria-label', text.enlarge + ' ' + variant.name);
      error.hidden = true;
      updatePrice();
    }
    $$('[data-variant]').forEach(button => button.addEventListener('click', () => {
      const next = data.variants.find(item => item.id === Number(button.dataset.variant));
      if (!next || !next.available || busy) return;
      variant = next;
      updateFlavor();
    }));
    $$('input[name="ozs_plan"]').forEach(input => input.addEventListener('change', updatePrice));
    frequency.addEventListener('change', updatePrice);
    $$('.ozs-image-open').forEach(button => button.addEventListener('click', () => {
      const dialog = $('#ozs-image-dialog');
      dialog.classList.toggle('ozs-portrait', button.dataset.image.includes('kitchen-timeline'));
      $('#ozs-dialog-image').src = button.dataset.image;
      $('#ozs-dialog-image').alt = button.dataset.caption;
      $('#ozs-dialog-caption').textContent = button.dataset.caption;
      dialog.showModal();
    }));
    $('.ozs-dialog-close').addEventListener('click', () => $('#ozs-image-dialog').close());
    $('#ozs-image-dialog').addEventListener('click', event => {
      if (event.target !== event.currentTarget) return;
      const rect = event.currentTarget.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.currentTarget.close();
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || !variant.available) return;
      const payload = {id:variant.id, quantity:1};
      if (!frequency.disabled) payload.selling_plan = Number(frequency.value);
      busy = true;
      error.hidden = true;
      updatePrice();
      form.setAttribute('aria-busy','true');
      try {
        const response = await fetch(root.dataset.cartAdd, {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify(payload)});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || text.cart_error);
        // Straight to checkout (snippets/ozzi-checkout). busy stays set until the browser leaves.
        // No helper means the theme editor (or a layout without it): checkout cannot load in the
        // editor's frame, so there the button is simply put back.
        if (window.OzziCheckout) window.OzziCheckout.go();
        else if (window.Shopify && window.Shopify.designMode) { busy = false; form.removeAttribute('aria-busy'); updatePrice(); }
        else window.location.assign('/checkout');
      } catch (problem) {
        error.textContent = problem.message || text.cart_error;
        error.hidden = false;
        busy = false;
        form.removeAttribute('aria-busy');
        updatePrice();
      }
    });
    let pastShop = false;
    let footerVisible = false;
    const updateSticky = () => $('.ozs-sticky-shop').classList.toggle('ozs-visible', pastShop && !footerVisible);
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      pastShop = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      updateSticky();
    });
    const footerObserver = new IntersectionObserver(entries => {
      footerVisible = entries[0].isIntersecting;
      updateSticky();
    });
    observer.observe($('.ozs-buy-panel'));
    const footer = document.querySelector('footer');
    if (footer) footerObserver.observe(footer);
    updateFlavor();

    const motion = root.querySelector('.ozs-powder-video');
    if (motion) {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let motionVisible = false;
      motion.controls = false;
      motion.muted = true;
      motion.defaultPlaybackRate = 0.65;
      motion.playbackRate = 0.65;
      motion.autoplay = !reducedMotion.matches;
      const updateMotion = () => {
        if (motionVisible && !document.hidden && !reducedMotion.matches) motion.play().catch(() => {});
        else motion.pause();
      };
      const motionObserver = new IntersectionObserver(entries => {
        motionVisible = entries[0].isIntersecting;
        updateMotion();
      }, {threshold: 0.2});
      const handleMotionPreference = () => {
        motion.autoplay = !reducedMotion.matches;
        updateMotion();
      };
      reducedMotion.addEventListener('change', handleMotionPreference);
      document.addEventListener('visibilitychange', updateMotion);
      motionObserver.observe(motion);
      root.addEventListener('ozs:destroy', () => {
        motionObserver.disconnect();
        reducedMotion.removeEventListener('change', handleMotionPreference);
        document.removeEventListener('visibilitychange', updateMotion);
        motion.pause();
      }, {once: true});
    }
    root.classList.add('ozs-ready');
    root.addEventListener('ozs:destroy', () => { observer.disconnect(); footerObserver.disconnect(); }, {once:true});
  }
  initialize(document.getElementById('ozzi-seed-landing'));
  document.addEventListener('shopify:section:load', event => initialize(event.target.querySelector('#ozzi-seed-landing')));
  document.addEventListener('shopify:section:unload', event => event.target.querySelector('#ozzi-seed-landing')?.dispatchEvent(new Event('ozs:destroy')));
})();


  } catch(e) { console.error(e); }
})();
})();
